<template lang="pug">
	.swiper-container#select-campus(ref="swiper" v-cloak)
		.swiper-wrapper
			.swiper-slide.empty
			.swiper-slide(:class='state')
				.main.easy-scroll(:class='state')
					.loading-indicator(v-if='false')
						.loading-circles
							span
							span
							span
					.top-bar
						.header Select Your Campus
						.sub-header To view the courses that are avaialable to you, select the campus you will or currently attend for high school.
					.wrapper
						.loading-indicator(v-if="!schools")
							.loading-circles
								span
								span
								span
						.schoolListWrapper(v-else)
							.campusWrapper(v-for='school in schools')
								.schoolLink(@click='setCampus( school )')
									p {{ school.name }}
									.icon-chevRight
</template>

<script>
import Swiper from 'swiper';

export default {
  name : 'campus-select-popup',
  data : () => ( {
    swiper              : null,
    activeSlide         : 0,
    loadingCampusSelect : true,
    // state    : 'closed'
  } ),

  computed : {
    state() {
      return this.$store.state.campusSelectState;
    },

    isOpen() {
      return this.$store.getters.campusSelectModalOpen;
    },

    schools() {
      const { schools } = this.$store.getters;
      return schools.concat( [{ id : 'All', name : 'View all district courses' }] );
    },

    schoolsLoading() {
      return this.$store.getters.schoolsLoading;
    }
  },

  mounted() {
    this.initSwiper();
    setTimeout( () => {
      this.loadingCampusSelect = false;
    }, 3000 );
  },

  watch : {
    isOpen( isOpen ) {
      if ( !this.swiper ) {
        return;
      }
      if ( isOpen ) {
        this.swiper.slideTo( 1 );
        this.activeSlide = 1;
        setTimeout( () => {
          this.loadingCampusSelect = false;
        }, 200 );
      }
      else {
        this.swiper.slideTo( 0 );
        this.activeSlide = 0;
        this.loadingCampusSelect = true;
      }
    },
  },

  methods : {
    initSwiper() {
      const self = this;
      const { swiper } = this.$refs;
      this.swiper = new Swiper( swiper, {
        // auto initialize this swiiper
        init         : true,
        initialSlide : this.activeSlide,

        // swiper settings
        slidesPerView   : 1, // force every slide to be 100vw
        speed           : 400, // ms for when yoiu let go of swipe
        spaceBetween    : 0, // no space between
        resistanceRatio : 0, // stops you from swiping past all slides
        direction       : window.innerWidth > 375 ? 'vertical' : 'horizontal',

        threshold : 50, // min distance for scroll to work

        on : {
          /**
					 * Active index (I think) determines whether or not the slide is open
					 * If this.activeIndex === 1, then open; otherwise, closed
					 */
          activeIndexChange() {
            // console.log( 'active index changed', this.activeIndex, this );
            if ( this.activeIndex === 1 ) self.$store.dispatch( 'openCampusSelect' );
            else self.$store.dispatch( 'closeCampusSelect' );
          }
        }
      } );
    },

    setCampus( campus ) {
      const { id } = campus;
      if ( id === 'All' ) {
        this.$store.dispatch( 'setSchool', 'All' );
      }
      else {
        this.$store.dispatch( 'saveSchool', id );
        this.$store.dispatch( 'setSchool', id );
      }
      this.$store.dispatch( 'closeCampusSelect' );
    }
  }
};
</script>

<style lang="scss" scoped>
#select-campus {
	.swiper-slide.empty + .swiper-slide {
		background: rgba(255,255,255,0.8) !important;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.main {
		background: white;
		border-radius: 10px;
		box-shadow: $floatingObject;
		overflow: hidden;
		width: 80%;
		max-width: 800px;
		opacity: 0;
		transition: opacity 0.2s ease;
		position: relative;
		max-height: 800px;
		overflow: auto;
		.loading-indicator {
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			z-index: 10;
			background: white;
			border-radius: 10px;
			.loading-circles {
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
			}
		}
		&.open {
			opacity: 1;
		}
		.top-bar {
			width: 100%;
			height: 20%;
			padding: 30px;
			padding-bottom: 10px;
			background: $primary;
			color: white;
			font-family: "Work Sans", sans-serif;
			.header {
				font-family: inherit;
				font-weight: 600;
				font-size: 22px;
				line-height: 21px;
				letter-spacing: -0.05em;
				padding-bottom: 10px;
			}
			.sub-header {
				font-family: inherit;
				font-weight: 300;
				font-size: 14px;
				line-height: 18px;
				letter-spacing: -0.03em;
				@include md {
					width: 65%;
				}
			}
		}
		.wrapper {
			.schoolListWrapper {
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: space-between;
				flex-wrap: wrap;
				padding: 10px 0;

				@include md {
					flex-direction: row;
					padding: 10px;
				}
				.campusWrapper {
					width: 100%;
					padding: 0 20px;
					transition: background-color .2s ease;
					&:hover {
						background-color: rgba(38, 104, 208, 0.12);
					}
					@include md {
						width: 45%;
						border-radius: 4px;
						padding: 0 10px;
					}
					.schoolLink {
						display: flex;
						align-items: center;
						justify-content: space-between;
						width: 100%;
						padding: 5px;
						margin: 5px;
						cursor: pointer;
						p {
							font-family: "Work Sans", sans-serif;
							font-weight: 500;
							font-size: 18px;
							line-height: 19px;
							letter-spacing: -0.03em;
							color: #4f4f4f;
						}
						.icon-chevRight {
							position: relative;
							height: 10px;
							width: 10px;
							margin-left: 5px;
							&::before {
								content: "";
								position: absolute;
								height: 2px;
								width: 10px;
								border-radius: 25px;
								background-color: #4f4f4f;
								transform: rotate(45deg);
							}
							&::after {
								content: "";
								position: absolute;
								height: 2px;
								width: 10px;
								border-radius: 25px;
								background-color: #4f4f4f;
								transform: rotate(-45deg) translate(-4px, 4px);
							}
						}
					}
				}
			}
		}
	}
}

</style>
